import { get } from "lodash";

export const SOURCE_AVAILABILITY = {
  AVAILABLE: "AVAILABLE",
  NOT_STARTED: "NOT_STARTED",
  CLOSED: "CLOSED",
};

const errorToAvailability = {
  SOURCE_NOT_STARTED: SOURCE_AVAILABILITY.NOT_STARTED,
  SOURCE_CLOSED: SOURCE_AVAILABILITY.CLOSED,
};

export const isUnavailable = (status) =>
  status === SOURCE_AVAILABILITY.NOT_STARTED ||
  status === SOURCE_AVAILABILITY.CLOSED;

/**
 * The API refuses `addProject` with SOURCE_NOT_STARTED / SOURCE_CLOSED;
 * returns the matching availability, or null for any other error.
 */
export const availabilityFromError = (error) => {
  const messages = [
    get(error, "message"),
    ...get(error, "graphQLErrors", []).map(({ message }) => message),
  ];
  const match = messages.find((message) => errorToAvailability[message]);
  return match ? errorToAvailability[match] : null;
};
